type Row = Record<string, unknown>;
interface InventoryEntryReaders {
    entries: (row: Row | null, key: string) => unknown[];
    inventoryField: (row: Row | null, key: string) => unknown;
}

/** Find the first exact carried instance, including container contents, in inventory order. */
export function findCarriedInventoryEntry<T extends Row = Row>(caster: Row, inventoryId: string, read: InventoryEntryReaders): T | null {
    const want = inventoryId.toUpperCase();
    const scan = (rows: unknown[]): T | null => {
        for (const raw of rows) {
            if (!raw || typeof raw !== 'object' || Array.isArray(raw)) continue;
            const row = raw as T;
            if (String(read.inventoryField(row, 'inventory_id') ?? '').toUpperCase() === want) return row;
            const hit = scan(read.entries(row, 'inventory_in_container'));
            if (hit) return hit;
        }
        return null;
    };
    return scan(read.entries(caster, 'inventory'));
}
